import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { LOAD_FAILURE_QUERY_OPTIONS } from '../lib/load-failure';
import type { FieldTask } from './useFieldToday';

export interface FieldHistoryResponse {
  items: FieldTask[];
  nextCursor?: string;
}

export function useFieldHistory(type = 'all') {
  return useQuery<FieldHistoryResponse>({
    queryKey: ['field-history', type],
    queryFn: () => api.field.history({ type }).then((r) => r.data?.data ?? r.data),
    staleTime: 30_000,
    // A refusal is an answer, not a flake: no retries on a 403, and a failure
    // that HistoryPage can tell from "No items".
    ...LOAD_FAILURE_QUERY_OPTIONS,
  });
}
